(function(){
	'use strict';
	var $ = avm.require('jquery'),
		waypoints = avm.require('avast.web.waypoints'),
		$document = $(document),
		$window = $(window),
		$carousel = $('.js-carousel'),
		$view = $('.js-view'),
		$arrowLeft = $('.js-arrow-left'),
		$arrowRight = $('.js-arrow-right'),
		$bullets = $('.js-bullets'),
		$bullet = $('.js-bullet');

	function initCarousel() {
		$arrowLeft.add($arrowRight).add($bullet).add($view).on('click', switchingCarousel);
	}

	function carouselAnimation() {
		if (waypoints($carousel, 0.75) && !$carousel.hasClass('intro-animation')) {
			$view.eq(0).addClass('active');
			initCarousel();
			$window.off('scroll', carouselAnimation);
		}
	}

	function switchingCarousel(event) {
		var $target = $(event.target),
			activeIndex = $view.index($('.js-view.active')),
			index;
			console.log($target);

		if ($target.hasClass('js-arrow-left')) {
			if (activeIndex === 0) {
				index = $view.length - 1;
			} else {
				index = activeIndex - 1;
			}
		} else if ($target.hasClass('js-arrow-right') || $target.hasClass('js-view')) {
			if (activeIndex === $view.length - 1) {
				index = 0;
			} else {
				index = activeIndex + 1;
			}
		} else if ($bullets.find($target).length > 0) {
			index = $bullet.index($target);
		}

		if (activeIndex !== index) {
			$view.removeClass('active');
			$bullet.removeClass('active');
			$view.eq(index).addClass('active');
			$bullet.eq(index).addClass('active');
		}

		// Enabling/disabling arrows
		if (index === 0) {
			$arrowLeft.addClass('disabled');
		} else {
			$arrowLeft.removeClass('disabled');
		}

		if (index === $view.length - 1) {
			$arrowRight.addClass('disabled');
		} else {
			$arrowRight.removeClass('disabled');
		}
	}

	$document.ready(carouselAnimation);

	$window.on('scroll', carouselAnimation);
})();
